import React from 'react';
type ContainerProps = {
  children: React.ReactNode;
  className?: string;
  narrow?: boolean;
};
export function Container({
  children,
  className = '',
  narrow = false
}: ContainerProps) {
  return <div className={`mx-auto w-full px-5 sm:px-6 ${narrow ? 'max-w-prose2' : 'max-w-content'} ${className}`} data-id="element-34" data-mp="3bj4assodcqhr">
      {children}
    </div>;
}